import React from "react"
import ProductsSlider from "../components/ProductsSlider";

const ProductsP = () => {
    return(
        <div>
            <ProductsSlider />
        </div>
    )
}
export default ProductsP;